import { render, staticRenderFns } from "./CommonSchoolImageUpload.vue?vue&type=template&id=1f073cc2&scoped=true&"
import script from "./CommonSchoolImageUpload.vue?vue&type=script&lang=js&"
export * from "./CommonSchoolImageUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f073cc2",
  null
  
)

export default component.exports